import { render, staticRenderFns } from "./ActivityDialog.vue?vue&type=template&id=c124c0a6&scoped=true&"
import script from "./ActivityDialog.vue?vue&type=script&lang=js&"
export * from "./ActivityDialog.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDialog.vue?vue&type=style&index=0&id=c124c0a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c124c0a6",
  null
  
)

export default component.exports